module.exports = __webpack_public_path__ + "img/mini-009.eb33c34c.jpg";